<template>
  <svg
    width="74"
    height="74"
    viewBox="0 0 74 74"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M12.3346 24.666H61.668C65.0751 24.666 67.8346 27.4256 67.8346 30.8327V61.666C67.8346 65.0731 65.0751 67.8327 61.668 67.8327H12.3346C8.92755 67.8327 6.16797 65.0731 6.16797 61.666V30.8327C6.16797 27.4256 8.92755 24.666 12.3346 24.666Z"
      :stroke="clr ? clr : '#CFCFCF'"
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M42.4519 40.7987C45.4622 43.809 45.4622 48.6897 42.4519 51.7C39.4416 54.7102 34.561 54.7102 31.5507 51.7C28.5404 48.6897 28.5404 43.809 31.5507 40.7987C34.561 37.7884 39.4416 37.7884 42.4519 40.7987"
      :stroke="clr ? clr : '#CFCFCF'"
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M55.4987 53.9577V38.541"
      :stroke="clr ? clr : '#CFCFCF'"
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M18.4987 53.9577V38.541"
      :stroke="clr ? clr : '#CFCFCF'"
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M61.6654 15.4167H12.332"
      :stroke="clr ? clr : '#CFCFCF'"
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M58.5846 6.16667H15.418"
      :stroke="clr ? clr : '#CFCFCF'"
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
</template>
<script>
export default {
  props: ["clr"]
};
</script>
